export default "__VITE_ASSET__Bw3zV02x__"